import React from 'react'
import { ArrowUpNarrowWide, ArrowDownWideNarrow, ChevronsUpDown } from 'lucide-react'
import { SortDirection } from './useTableSettings'
import { TranslationKey } from '@/modules/i18n'

export interface ColumnDef {
  key: string
}

export type FilterType = 'text' | 'enum'

export interface EnumFilterOption {
  value: string
  label: TranslationKey
  component?: React.ReactNode
}

/**
 * Generate default visible columns based on available columns
 */
export const getDefaultVisibleColumns = <T extends string>(
  availableColumns: Array<{ key: T }>
): Record<string, boolean> => {
  const defaults: Record<string, boolean> = {}
  availableColumns.forEach(col => {
    defaults[col.key] = true
  })
  return defaults
}

/**
 * Custom toggle column visibility that prevents toggling off protected columns
 */
export const createToggleColumnVisibilityWithProtectedColumn = <T extends string>(
  originalToggleColumnVisibility: (columnKey: string) => void,
  protectedColumnKey: T
) => {
  return (columnKey: string) => {
    if (columnKey === protectedColumnKey) {
      // Always keep protected column visible, don't allow toggling off
      return
    }
    originalToggleColumnVisibility(columnKey)
  }
}

/**
 * Render sort icon based on sort state
 */
export const renderSortIcon = (sortState: SortDirection): React.ReactNode => {
  if (sortState === 'asc') {
    return <ArrowUpNarrowWide className="h-4 w-4 min-h-4 min-w-4 text-accent" />
  }
  if (sortState === 'desc') {
    return <ArrowDownWideNarrow className="h-4 w-4 min-h-4 min-w-4 text-accent" />
  }
  // Show up-down arrow on hover when not sorted
  return (
    <ChevronsUpDown className="min-h-3 min-w-3 h-3 w-3 opacity-0 group-hover:opacity-50 transition-opacity" />
  )
}
